module.exports = __webpack_public_path__ + "media/images/lp_team-txt-d0ea5f5b7ecbc8e333b09531d75db03d.webp";